import { z } from 'zod';
import type { WishlistTemplateToken } from '@sleed/bizcommerce-api';

/**
 * Wishlist template edit form. Mirrors `WishlistTemplateToken` and the legacy admin popup
 * (Core/client/admin/src/pages/Catalog/WishlistTemplates/index.js): nm required ≤200, cd required ≤200,
 * iv boolean, si required, plus a many-to-many product set (ProductIds). The default-language name is
 * saved at the top level via the Accept-Language=el pin (parity with the other catalog grids).
 */
export const wishlistTemplateSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(200, 'validation.tooLong'),
	cd: z.string().trim().min(1, 'validation.required').max(200, 'validation.tooLong'),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int(),
	productIds: z.array(z.number())
});

export type WishlistTemplateFormValues = z.infer<typeof wishlistTemplateSchema>;

export const EMPTY_WISHLIST_TEMPLATE: WishlistTemplateFormValues = {
	nm: '',
	cd: '',
	iv: true,
	si: 0,
	productIds: []
};

export function tokenToForm(token: WishlistTemplateToken): WishlistTemplateFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		cd: token.cd ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0,
		productIds: token.ProductIds ?? (token.Products ?? []).map(p => p.id!).filter(id => id != null)
	};
}

export function formToToken(form: WishlistTemplateFormValues): WishlistTemplateToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		cd: form.cd.trim(),
		iv: form.iv,
		si: form.si,
		ProductIds: form.productIds
	};
}
